/** Mirrors the backend's `@vv/audit-log-backend` domain constants - duplicated
 * here since the frontend and backend are separate workspaces/deployments. */
export enum AuditEntityType {
  Team = "Team",
  User = "User",
  ValidationRequest = "ValidationRequest",
}

export const ALL_AUDIT_ENTITY_TYPES: AuditEntityType[] = Object.values(AuditEntityType);

export const AUDIT_ENTITY_TYPE_LABELS: Record<AuditEntityType, string> = {
  [AuditEntityType.Team]: "Team",
  [AuditEntityType.User]: "User",
  [AuditEntityType.ValidationRequest]: "Validation request",
};

export enum AuditAction {
  TeamCreated = "team.created",
  TeamUpdated = "team.updated",
  TeamMemberAdded = "team.member_added",
  TeamMemberRemoved = "team.member_removed",
  UserInvited = "user.invited",
  UserUpdated = "user.updated",
  RequestSubmitted = "request.submitted",
  RequestAccepted = "request.accepted",
  RequestRejected = "request.rejected",
  RequestAssigned = "request.assigned",
  RequestStarted = "request.started",
  RequestCompleted = "request.completed",
  RequestReworkRequested = "request.rework_requested",
  RequestReworkRejected = "request.rework_rejected",
  /** Historical only - `close`/`Closed` no longer exist, but real rows with this action already exist from before the removal. */
  RequestClosed = "request.closed",
}

export const ALL_AUDIT_ACTIONS: AuditAction[] = Object.values(AuditAction);

export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  [AuditAction.TeamCreated]: "Team created",
  [AuditAction.TeamUpdated]: "Team updated",
  [AuditAction.TeamMemberAdded]: "Member added",
  [AuditAction.TeamMemberRemoved]: "Member removed",
  [AuditAction.UserInvited]: "User invited",
  [AuditAction.UserUpdated]: "User updated",
  [AuditAction.RequestSubmitted]: "Request submitted",
  [AuditAction.RequestAccepted]: "Request accepted",
  [AuditAction.RequestRejected]: "Request rejected",
  [AuditAction.RequestAssigned]: "Request assigned",
  [AuditAction.RequestStarted]: "Request started",
  [AuditAction.RequestCompleted]: "Request completed",
  [AuditAction.RequestReworkRequested]: "Rework requested",
  [AuditAction.RequestReworkRejected]: "Rework request denied",
  [AuditAction.RequestClosed]: "Request closed",
};

export interface AuditLogEntry {
  id: string;
  actorUserId: string | null;
  action: AuditAction;
  entityType: AuditEntityType;
  entityId: string;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface ListAuditLogFilter {
  entityType?: AuditEntityType;
  action?: AuditAction;
  actorUserId?: string;
}
